import { Component, OnInit, NgZone } from '@angular/core';
import { SignalrErrorDialogComponent } from './signalr-error-dialog.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-signalr-error',
  templateUrl: './signalr-error.component.html',
  styleUrls: ['./signalr-error.component.css']
})
export class SignalrErrorComponent implements OnInit {

  signalrModalRef: MatDialogRef<SignalrErrorDialogComponent>;

  constructor(private dialog: MatDialog, private router: Router, private zone: NgZone) { }

  ngOnInit() {
    this.signalrModalRef=this.dialog.open(SignalrErrorDialogComponent, { width: '600px', height:'600px', disableClose:true, closeOnNavigation:false});
    this.signalrModalRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      this.zone.run(() => this.router.navigate(['/']));
    });
   
  }

}
